var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "card" } },
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c(
            "el-button",
            { on: { click: _vm.download } },
            [
              _c("d2-icon", { attrs: { name: "download" } }),
              _vm._v(" 下载演示 .csv 表格 ")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d2-mb" },
        [
          _c(
            "el-upload",
            { attrs: { "before-upload": _vm.handleUpload, action: "default" } },
            [
              _c(
                "el-button",
                { attrs: { type: "success" } },
                [
                  _c("d2-icon", { attrs: { name: "file-o" } }),
                  _vm._v(" 选择要导入的 .csv 表格 ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        _vm._b({}, "el-table", _vm.table, false),
        _vm._l(_vm.table.columns, function(item, index) {
          return _c("el-table-column", {
            key: index,
            attrs: { prop: item.prop, label: item.label }
          })
        }),
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }